const DAY_MS = 24 * 60 * 60 * 1000;

// Match Frappe's site-local datetime arithmetic, including across DST changes.
// Use the response Date header rather than the cashier's device clock.
export const getOldDraftCutoff = (serverDate, timeZone) => {
    // A reverse proxy can append its Date to the origin Date header. Use the
    // final complete HTTP-date, not the combined (invalid JavaScript) string.
    const dates = String(serverDate || "").match(/(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), \d{2} [A-Za-z]{3} \d{4} \d{2}:\d{2}:\d{2} GMT/g);
    const now = new Date(dates?.[dates.length - 1] || serverDate);
    if (!timeZone || !Number.isFinite(now.getTime())) {
        throw new Error("Site time unavailable");
    }
    const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
        timeZone, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
    }).formatToParts(now).map(({ type, value }) => [type, value]));
    const wallTime = Date.UTC(Number(parts.year), Number(parts.month) - 1,
        Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
    return new Date(wallTime - 30 * DAY_MS).toISOString().slice(0, 19).replace("T", " ");
};

export const isOldDraft = (creation, cutoff) => {
    // Compare normalized wall times without losing Frappe's microseconds.
    const normalize = (value) => {
        const match = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?$/.exec(value || "");
        return match ? `${match[1]} ${match[2]}.${(match[3] || "").padEnd(6, "0")}` : null;
    };
    const created = normalize(creation);
    const threshold = normalize(cutoff);
    return !!created && !!threshold && created < threshold;
};

export const matchesRetailDraft = (draft, { search = "", customerName, oldOnly = false, cutoff } = {}) =>
    (!oldOnly || isOldDraft(draft.creation, cutoff)) &&
    [draft.customer, draft.tracking_number, customerName].some((value) =>
        String(value || "").toLowerCase().includes(search.trim().toLowerCase()));
